import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import map from './imageFiles/map.png';

const Map = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img src={map} style={{ width: '100%' }} alt="Map Illustration" />
  </Box>
);
export default Map;
